export const ExitIcon = () => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.49978 0H8.43709C8.74645 0 8.99956 0.253113 8.99956 0.562473V1.68742C8.99956 1.99678 8.74645 2.24989 8.43709 2.24989H4.49978C3.25765 2.24989 2.24989 3.25765 2.24989 4.49978V13.4993C2.24989 14.7415 3.25765 15.7492 4.49978 15.7492H8.43709C8.74645 15.7492 8.99956 16.0023 8.99956 16.3117V17.4366C8.99956 17.746 8.74645 17.9991 8.43709 17.9991H4.49978C2.01553 17.9991 0 15.9836 0 13.4993V4.49978C0 2.01553 2.01553 0 4.49978 0ZM15.3321 0.914018L14.4134 1.83272C14.1884 2.05771 14.1931 2.41863 14.4227 2.63425L19.724 7.78087H8.06211C7.75275 7.78087 7.49963 8.03398 7.49963 8.34334V9.65578C7.49963 9.96514 7.75275 10.2183 8.06211 10.2183H19.724L14.4227 15.3602C14.1977 15.5805 14.1931 15.9414 14.4134 16.1617L15.3321 17.0804C15.5524 17.3007 15.9086 17.3007 16.1289 17.0804L23.8348 9.39329C24.0551 9.17299 24.0551 8.81676 23.8348 8.59645L16.1289 0.909331C15.9086 0.693716 15.5524 0.693716 15.3321 0.914018Z"
        fill="#4B5851"
      />
    </svg>
  );
};
